import {InjectionKey, Ref} from "vue";

export const DateFilterKey: InjectionKey<Ref<string | undefined>> = Symbol("DateFilter");
export const DateFilterUnitKey: InjectionKey<Ref<string | undefined>> = Symbol("DateFilterUnit");
export const DateFilterValueKey: InjectionKey<Ref<string | string[] | undefined>> = Symbol("DateFilterValue");
export const TenantFilterKey: InjectionKey<Ref<string | undefined>> = Symbol("TenantFilter");
export const InstitutionFilterKey: InjectionKey<Ref<string | undefined>> = Symbol("InstitutionFilter");
export const CohortFilterKey: InjectionKey<Ref<string | undefined>> = Symbol("CohortFilter");
export const SchoolCurriculumFilterKey: InjectionKey<Ref<string | undefined>> = Symbol("SchoolCurriculumFilter");
